<template>
  <div id="main-content" class="student-list clearfix">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button type="success" @click="goToImport">{{ $t('common.import') }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <template v-if="data">
        <el-row style="padding-top: 20px">
          <table class="bus-list filter-sort-table">
            <tr>
              <th width="3%" class="input-th">#</th>
              <th width="12%" class="input-th">
                <el-input :placeholder="$t('common.full_name')" v-model="filter.fullname"></el-input>
                <Sort :model="sort.fullname" @change="changeSort($event, 'fullname')"></Sort>
              </th>
              <th width="12%" class="input-th">
                <el-input :placeholder="$t('common.romaji')" v-model="filter.romaji"></el-input>
                <Sort :model="sort.romaji" @change="changeSort($event, 'romaji')"></Sort>
              </th>
              <th width="12%" class="input-th">
                <el-input :placeholder="$t('common.furigana')" v-model="filter.furigana"></el-input>
                <Sort :model="sort.furigana" @change="changeSort($event, 'furigana')"></Sort>
              </th>
              <th width="10%" class="input-th">
                <el-select v-model="filter.class_id" collapse-tags :placeholder="$t('common.class')">
                  <el-option
                    v-for="classroom in sortedClassList"
                    :key="classroom.id"
                    :label="classroom.name"
                    :value="classroom.id">
                  </el-option>
                </el-select>
                <Sort :model="sort.class" @change="changeSort($event, 'class')"></Sort>
              </th>
              <th width="10%" class="input-th">
                <el-select v-model="filter.gender">
                  <el-option :label="$t('common.gender')" value=""></el-option>
                  <el-option :label="$t('common.female')" :value="0"></el-option>
                  <el-option :label="$t('common.male')" :value="1"></el-option>
                </el-select>
                <Sort :model="sort.gender" @change="changeSort($event, 'gender')"></Sort>
              </th>
              <th width="15%" class="input-th">
                <el-input :placeholder="$t('common.parent_name')" v-model="filter.parent_name"></el-input>
                <Sort :model="sort.parent_name" @change="changeSort($event, 'parent_name')"></Sort>
              </th>
              <th width="15%" class="input-th">
                <el-select v-model="filter.place_id" collapse-tags :placeholder="$t('common.bus_stop')">
                  <el-option
                    v-for="place in sortedBusStopList"
                    :key="place.id"
                    :label="place.name"
                    :value="place.id">
                  </el-option>
                </el-select>
                <Sort :model="sort.place" @change="changeSort($event, 'place')"></Sort>
              </th>
              <th>
                <el-button @click="resetFilter"
                           style="margin: 2px;" type="danger">{{ $t('common.reset') }}
                </el-button>
              </th>
            </tr>
            <tr v-for="(student, index) in data.data" :key="student.id">
              <td width="5%">{{ data.from + index }}</td>
              <td>{{ student.fullname }}</td>
              <td>{{ student.romaji }}</td>
              <td>{{ student.furigana }}</td>
              <td>{{ student.class_name }}</td>
              <td v-if="student.gender === 0">{{ $t('common.female') }}</td>
              <td v-else>{{ $t('common.male') }}</td>
              <td>
                <a href="#" @click="goParent($event, student.parent.id)">
                  {{ student.parent_name }}
                </a>
              </td>
              <td>{{ student.place_name }}</td>
              <td>
                <b-button variant="outline-primary" @click="goToDetailStudent(student.id)"
                          style="margin-right: 10px">{{ $t('common.detail') }}
                </b-button>
                <b-button variant="danger" @click="deleteStudent(student.id)">{{ $t('common.delete') }}</b-button>
                <b-button v-if="student.is_active" variant="primary" @click="onSendEmailToParent(student.id)">{{ $t('sendEmailStudent') }}</b-button>

              </td>
            </tr>
          </table>
        </el-row>
        <el-row style="padding-top: 15px">
          <el-pagination
            v-show="data.total > data.per_page"
            background
            @current-change="didSelectPage"
            :page-size="data.per_page"
            layout="prev, pager, next"
            :current-page="page"
            :total="data.total">
          </el-pagination>
        </el-row>
      </template>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PageTitle from '@/components/PageTitle'
  import Sort from "@/components/Sort"
  import { basicSort } from '@/utils'

  export default {
    name: 'ListStudent',
    components: {
      PageTitle,
      Sort
    },
    data: function () {
      return {
        backLink: ``,
        title: 'common.student_list',
        page: 1,
        filter: {
          class_id: '',
          gender: '',
          place_id: '',
          fullname: '',
          parent_name: '',
          romaji: '',
          furigana: ''
        },
        sort: {
          class: null,
          gender: null,
          place: null,
          fullname: null,
          parent_name: null,
          romaji: null,
          furigana: null
        },
        isBack: false,
        data: null,
        filterTimeout: null
      }
    },
    methods: {
      onSendEmailToParent(id){
        let successCallback = (response) =>{
          if(response.status === 200){
            this.$store.commit('openNotification', {
              type: 'success',
              message: this.$t('parent_list.send_mail_success')
            })
          }
        }
        let errorCallback = () => {}
        let payload = {
          successCallback,
          errorCallback,
          idStudent: id
        }
        this.$store.dispatch('parent/sendEmailInfoStudent', payload)
      },
      goToAddStudent: function () {
        this.saveState()
        this.$router.push('/student/add')
      },
      goToDetailStudent(studentId) {
        this.saveState()
        this.$router.push({path: '/student/detail', query: {sid: studentId}});
      },
      goToImport: function () {
        this.saveState()
        this.$router.push('/student/import')
      },
      saveState: function () {
        this.$store.commit('student/updateState', {
          filter: this.filter,
          sort: this.sort,
          page: this.page
        })
      },
      deleteStudent(studentId) {
        this.$store.commit('openConfirm', {
          title: this.$t('common.delete'),
          message: this.$t('common.student_delete_confirm'),
          callback: () => {
            let payload = {
              student_id: studentId,
              successCallback: () => {
                if (this.data.data.length <= 1) {
                  this.page = this.page > 1 ? this.page - 1 : 1
                }

                this.retrieveData()
              }
            }

            this.$store.dispatch('student/deleteStudent', payload)
          }
        })
      },
      didSelectPage: function (e) {
        this.page = e
        this.retrieveData()
      },
      resetFilter: function () {
        this.filter = Object.assign({}, {
          class_id: '',
          gender: '',
          place_id: '',
          fullname: '',
          parent_name: '',
          romaji: '',
          furigana: ''
        })

        this.sort = Object.assign({}, {
          class: null,
          gender: null,
          place: null,
          fullname: null,
          parent_name: null,
          romaji: null,
          furigana: null
        })
      },
      changeSort (type, field) {
        this.sort[field] = type
        this.sort = Object.assign({}, this.sort)
        this.retrieveData()
      },
      retrieveData: function () {
        let filter = this.filter
        let sort = this.sort
        let page = this.page
        let successCallback = (response) => {
          this.data = Object.assign({}, response.data.data)
        }

        this.$store.dispatch('student/retrieveStudentList', {
          filter, sort, page, successCallback
        })
      },
      goParent (event, parentId) {
        event.preventDefault()

        if (parentId) {
          this.$router.push({path: '/parent/detail', query: { pid: parentId, referer: 'student' }})
        }
      }
    },
    created: function () {
      if (this.$route.query.action && this.$route.query.action === "back") {
        if (this.currentFilter) {
          this.filter = Object.assign({}, this.currentFilter)
          this.isBack = true
        }

        if (this.currentSort) {
          this.sort = Object.assign({}, this.currentSort)
        }

        if (this.currentPage) {
          this.page = this.currentPage
        }
      }

      this.$store.commit('student/updateState', {
        filter: null,
        sort: null,
        page: null
      })
    },
    mounted: function () {
      this.retrieveData()
      this.$store.dispatch('place/retrievePlaceList', {})
      this.$store.dispatch('classroom/retrieveClassList', {})
    },
    computed: {
      ...mapState('student', ['currentFilter', 'currentSort', 'currentPage']),
      ...mapState('classroom', ['classList']),
      ...mapState('place', ['placeList']),
      sortedClassList: function () {
        let sortedClassList = [].concat(this.classList)
        return sortedClassList.sort((before, after) => basicSort(before, after, 'name'))
      },
      sortedBusStopList: function () {
        let sortedBusStopList = [].concat(this.placeList)
        return sortedBusStopList.sort((before, after) => basicSort(before, after, 'name'))
      }
    },
    watch: {
      filter: {
        deep: true,
        handler: function () {
          if (this.isBack) {
            this.isBack = false
            return
          }
          clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            this.retrieveData()
          }, 1000)

          this.page = 1
        }
      }
    }
  }
</script>
<style lang="scss">
  .bus-list {
    width: 100%;
  }

  table, th, td {
    border: 1px solid #DCDFE6;
    border-collapse: collapse;
  }

  th {
    height: 55px;
    background-color: rgba(0, 0, 0, 0.2);
    color: #fff;
  }

  td {
    height: 40px;
  }

  #main-content {
    min-height: calc(100vh - 280px);
  }

  .search-box {
    float: left;
    padding-right: 20px;
    font-size: 20px;
    line-height: 36px;
  }

  .filter-box {
    float: inherit;
    background-color: #fff;
    color: #776b6b;
  }

  .drop-form {
    line-height: 25px;
    font-size: 15px;
  }

  .drop-form-input {
    height: 30px;
    float: right;
  }

  .drop-list-container {
    width: 100%;
    height: 200px;
    clear: both;
    border: 1px solid #343a40;
    overflow: auto;
    padding: 5px 5px 0 5px
  }

  .drop-list-container input[type=checkbox] {
    width: 20px;
    height: 20px;
  }

  .bus-list #dropdown-form button.dropdown-toggle {
    background: #ffffff;
    border: none;
    color: #606266;
  }

  .filter-sort-table {
    th.input-th {
      box-sizing: border-box;
      padding-right: 24px!important;
      position: relative;

      select {
        width: 100%
      }

      &.no-sort {
        padding-right: 5px!important;
      }

      .sort {
        position: absolute;
        right: 0;
        top: 7px;

        i {
          font-size: 24px;
          line-height: 40px;
        }
      }
    }
  }
</style>
